export const bsc = {
    name: "BSC",
    iconUrl: "/images/bsc_icon.svg",
    CHAIN_ID: 56,
    customRpc: {"chainId":"0x38","chainName":"Binance Smart Chain","nativeCurrency":{"name":"BNB","symbol":"BNB","decimals":18},"rpcUrls":["https://bsc-dataseed.binance.org/"],"blockExplorerUrls":["https://bscscan.com"]},
    apiUrl: "https://a7lu4hc67i.execute-api.us-east-1.amazonaws.com/prod/",
    subgraphUrl: null,
    rpcWssUrl: null,
    rpcApiUrl: "https://bsc-dataseed.binance.org/",
    zrxApiUrl: null,
    zrxWSSUrl: null,
    zrxRequestPerSecond: 3,
    explorerUrl: "https://bscscan.com/address/",
    explorerTxUrl: "https://bscscan.com/tx/",
    swapUrl: "https://exchange.pancakeswap.finance/#/swap?outputCurrency=",
    gasApiUrl: null,
    gasPriceType: null,
    defaultGasPrice: null,
    hasAave: false,
    acoFactoryAddress: "0x58308717087de7eccd866196fb69edee557d326b",
    acoPoolFactoryAddress: "0x4db1d076ed0a3f2bb9b105d96edfb1671916f6ca",
    acoFlashExerciseAddress: "0xaf7da27761a62d0ee4a55a8577d565adae957acb",
    acoWriterAddress: null,
    zrxExchangeAddress: null,
    multicallAddress: null,
    allAcoOtcAddresses: ["0x4c9cd2bbc74290bc1b8da8af94c2836e341f1f78"],
    acoBuyerAddress: "0xb4f28d9aa4ae8070ba1dea1f2fd888a64b45aa17",
    acoDistributorAddress: null,
    acoRewardAddress: null,
    airdropClaimStart: null,
    acoAssetConverterHelperAddress: "0xb82a6e7d7e31da91b03699abfe7ea29cf683144f",
    auctusAddress: "0x3028b4395f98777123c7da327010c40f3c7cc4ef",
    usdAddress: "0xe9e7cea3dedca5984780bafc599bd69add087d56",
    wrapperAddress: "0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c",
    btcAddress: "0x7130d2a12b9bcbfae4f2634d864a1ee1ce3ead9c",
    ethAddress: "0x2170ed0880ac9a755fd29b2688956bd959f933f8",
    baseAddress: "0x0000000000000000000000000000000000000000",
    usdSymbol: "BUSD",
    btcSymbol: "BTCB",
    ethSymbol: "ETH",
    baseSymbol: "BNB",
    deprecatedPoolImplementation: ["0x8933f1924c8a05f972b3d94093a090d679bf089d"],
    acoVaults: null,
    acoVaultsV2: null,
    defaultPoolAdmin: "0x56803ed55c7182461f587fbbec509d45a0eb1260",
    defaultAcoCreators: ["0xc25a67941ae0897933fc9abd6862dc7c34d49155"],
    optionsToIgnore: [],
    acoRewardsPools: null,
    acoAirdropAmounts: null,
    coingeckoPlataform: "binance-smart-chain",
    coingeckoBaseAsset: "binancecoin",
    menuConfig: { hasAdvanced: false, hasVaults: false, hasOtc: true, hasFarm: false, hasCreateOption: false, hasPoolHistory: false }
}